document.addEventListener('DOMContentLoaded', () => {
  // ==========================================
  // 1. MENU DESKTOP
  // ==========================================
  const navContainer = document.querySelector('.header__inline-menu');

  if (navContainer) {
    const topLevelLinks = Array.from(navContainer.querySelectorAll('.list-menu > .menu-lv-1 > .menu-lv-1__action'));
    const desktopMenuItems = navContainer.querySelectorAll('.list-menu > .menu-lv-1');

    desktopMenuItems.forEach((container) => {
      const trigger = container.querySelector('.menu-lv-1__action');
      const panel = container.querySelector('.menu-dropdown');

      if (!trigger) return;

      // Gestione Apertura/Chiusura (solo se la voce ha un megamenu)
      const openMenu = () => {
        if (window.innerWidth < 1025 || !panel) return;
        trigger.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
      };

      const closeMenu = () => {
        if (window.innerWidth < 1025 || !panel) return;
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      };

      if (panel) {
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');

        container.addEventListener('mouseenter', openMenu);
        container.addEventListener('mouseleave', closeMenu);
        container.addEventListener('focusin', openMenu);

        container.addEventListener('focusout', (e) => {
          if (window.innerWidth < 1025) return;
          if (!container.contains(e.relatedTarget)) {
            closeMenu();
          }
        });
      }

      // Gestione Tastiera Avanzata (Attiva su TUTTE le voci della navbar)
      container.addEventListener('keydown', (e) => {
        if (window.innerWidth < 1025) return;

        const currentIndex = topLevelLinks.indexOf(document.activeElement);

        if (e.key === 'Escape' && panel) {
          closeMenu();
          trigger.focus();
        } else if (e.key === 'ArrowRight' && currentIndex !== -1) {
          // Freccia Destra: passa al link successivo della navbar
          e.preventDefault();
          const nextIndex = (currentIndex + 1) % topLevelLinks.length;
          topLevelLinks[nextIndex].focus();
        } else if (e.key === 'ArrowLeft' && currentIndex !== -1) {
          // Freccia Sinistra: passa al link precedente della navbar
          e.preventDefault();
          const prevIndex = (currentIndex - 1 + topLevelLinks.length) % topLevelLinks.length;
          topLevelLinks[prevIndex].focus();
        } else if (e.key === 'ArrowDown' && document.activeElement === trigger && panel) {
          // Freccia Giù: entra nel primo elemento del megamenu
          e.preventDefault();
          openMenu();
          const firstSubLink = panel.querySelector('a, button');
          if (firstSubLink) firstSubLink.focus();
        }
      });
    });
  }

  // ==========================================
  // 2. ACCESSIBILITÀ GLOBALE SLICK SLIDER
  // ==========================================
  if (window.jQuery) {
    const $ = window.jQuery;

    function fixSlickA11y($slider) {
      // 1. Rimuove ruoli errati dai contenitori dello slider
      $slider.removeAttr('role');
      $slider.find('.slick-track').removeAttr('role');

      // Gestione Frecce (Slick Arrows)
      $slider.find('.slick-arrow').removeAttr('role').each(function() {
        const $btn = $(this);
        
        // 1. Rimuove il ruolo dall'SVG e lo nasconde alle tecnologie assistive
        $btn.find('svg').removeAttr('role').attr({
          'aria-hidden': 'true',
          'focusable': 'false'
        });

        // 2. Garantisce un aria-label valido ed esplicito se assente o generico
        if ($btn.hasClass('slick-next')) {
          $btn.attr('aria-label', 'Slide successiva');
        } else if ($btn.hasClass('slick-prev')) {
          $btn.attr('aria-label', 'Slide precedente');
        }
      });

      // 2. Gestione Slide Clonate (Loop Infinito)
      const $clones = $slider.find('.slick-cloned');
      if ($clones.length) {
        $clones
          .attr('aria-hidden', 'true')
          .attr('inert', '')
          .removeAttr('role aria-roledescription aria-label'); // Rimuove l'identità di slide per gli screen reader

        $clones.find('a, button, input, select, textarea, [tabindex]').attr({
          'tabindex': '-1',
          'aria-hidden': 'true'
        });
      }

      // 3. Gestione Slide Reali (Nasconde quelle non attive dal flusso di lettura/focus)
      $slider.find('.slick-slide:not(.slick-cloned)').each(function() {
        const $slide = $(this);
        const isActive = $slide.hasClass('slick-active');

        if (isActive) {
          $slide.removeAttr('aria-hidden').removeAttr('inert');
          $slide.find('a, button, input, select, textarea').removeAttr('tabindex');
        } else {
          $slide.attr('aria-hidden', 'true');
          $slide.find('a, button, input, select, textarea').attr('tabindex', '-1');
        }
      });

      // 4. Corregge la lista dei pallini (dots)
      const $dots = $slider.find('.slick-dots');
      if (!$dots.length) return;

      $dots.removeAttr('role');
      const totalSlides = $dots.find('li').length;

      $dots.find('li').each(function(index) {
        const $li = $(this);
        const $btn = $li.find('button');
        const slideNum = index + 1;
        const isActive = $li.hasClass('slick-active');

        $li.removeAttr('aria-hidden aria-selected role aria-controls');
        
        $btn
          .removeAttr('role tabindex data-role aria-selected aria-controls')
          .attr('aria-label', 'Slide ' + slideNum + ' di ' + totalSlides)
          .attr('aria-current', isActive ? 'slide' : 'false');
      });
    }

    // A. Esecuzione immediata su slider già caricati
    $('.slick-slider').each(function() {
      fixSlickA11y($(this));
    });

    // B. Intercettazione eventi Slick per slider dinamici o aggiornati
    $(document).on('init reInit afterChange setPosition', '.slick-slider', function() {
      fixSlickA11y($(this));
    });

    // B. Gestione pallini nativi Liquid (.slider-dots) - Versione Ultra-Performante
    function syncNativeDots($dots) {
      $dots.find('li').each(function() {
        const $li = $(this);
        const $btn = $li.find('button');
        const isActive = $li.hasClass('active') || $li.hasClass('slick-active');
        const newState = isActive ? 'slide' : 'false';

        // CONTROLLO ANTI-LOOP/ANTI-REFLOW:
        // Modifica il DOM solo se lo stato cambia effettivamente
        if ($btn.attr('aria-current') !== newState) {
          $btn.attr('aria-current', newState);
        }
      });
    }

    // 1. Sincronizzazione iniziale
    $('.slider-dots').each(function() {
      syncNativeDots($(this));
    });

    // 2. Observer mirato: ascolta SOLO il cambio della classe CSS (zero impatto su scroll e CPU)
    if ('MutationObserver' in window) {
      const dotsObserver = new MutationObserver(function(mutations) {
        for (let i = 0; i < mutations.length; i++) {
          const mutation = mutations[i];
          if (mutation.attributeName === 'class') {
            const $dots = $(mutation.target).closest('.slider-dots');
            if ($dots.length) {
              syncNativeDots($dots);
            }
          }
        }
      });

      $('.slider-dots').each(function() {
        dotsObserver.observe(this, {
          attributes: true,
          attributeFilter: ['class'], // Ascolta ESCLUSIVAMENTE la proprietà class
          subtree: true               // Guarda anche i <li> figli
        });
      });
    }

    // C. Backup per lazy-loading
    setTimeout(function() {
      $('.slick-slider').each(function() {
        fixSlickA11y($(this));
      });
    }, 1500);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  // Individua il contenitore principale della ricerca (Form, Modal o Header Wrap)
  const getSearchWrapper = (element) => {
    if (!element) return null;
    return element.closest('form[action*="/search"]') ||
           element.closest('.header-search') ||
           element.closest('.header__search') ||
           element.closest('.search-modal') ||
           element.closest('.quickSearchResultsWrap')?.parentElement ||
           element.parentElement;
  };

  const closePanel = (panel) => {
    if (!panel) return;
    panel.style.display = 'none';
    panel.classList.remove('is-active', 'open', 'show');
  };

  const resetPanelStyle = (panel) => {
    if (!panel) return;
    // Rimuove lo stile inline display:none per consentire al JS del tema di riaprire i risultati
    if (panel.style.display === 'none') {
      panel.style.display = '';
    }
  };

  // ==========================================
  // 1. GESTIONE FOCUS (Navigazione fluida con Tab)
  // ==========================================
  document.addEventListener('focusin', (e) => {
    const target = e.target;

    // A. Se il focus entra nell'input di ricerca, resetta eventuali blocchi style
    if (target.matches('input[name="q"], input[type="search"]')) {
      const wrapper = getSearchWrapper(target);
      if (wrapper) {
        const panels = wrapper.querySelectorAll('.quickSearchResultsWrap, [data-predictive-search]');
        panels.forEach(resetPanelStyle);

        // Se c'è già testo digitato, notifica al tema di mostrare i risultati
        if (target.value.trim().length > 0) {
          target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      return;
    }

    // B. Controlla tutti i pannelli aperti
    const panels = document.querySelectorAll('.quickSearchResultsWrap, [data-predictive-search]');

    panels.forEach((panel) => {
      const isVisible = panel.offsetWidth > 0 || panel.offsetHeight > 0 || window.getComputedStyle(panel).display !== 'none';
      if (!isVisible) return;

      const wrapper = getSearchWrapper(panel);

      // SE IL NUOVO ELEMENTO FOCALIZZATO È DENTRO LA RICERCA (Input, Bottone o Link Risultati)
      // -> Non fare nulla! Lascia il pannello aperto senza "saltelli".
      if (wrapper && wrapper.contains(target)) {
        return;
      }

      // SE IL FOCUS È USCITO DALL'INTERA AREA DI RICERCA -> Chiudi il pannello
      closePanel(panel);
    });
  });

  // ==========================================
  // 2. GESTIONE TASTO ESCAPE
  // ==========================================
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const activeEl = document.activeElement;
      const wrapper = getSearchWrapper(activeEl);

      if (wrapper) {
        const panels = wrapper.querySelectorAll('.quickSearchResultsWrap, [data-predictive-search]');
        let wasClosed = false;

        panels.forEach((panel) => {
          const isVisible = panel.offsetWidth > 0 || panel.offsetHeight > 0 || window.getComputedStyle(panel).display !== 'none';
          if (isVisible) {
            closePanel(panel);
            wasClosed = true;
          }
        });

        if (wasClosed) {
          const input = wrapper.querySelector('input[name="q"], input[type="search"]');
          if (input) input.focus();
        }
      }
    }
  });

  document.addEventListener('input', function (event) {
    const slider = event.target;

    // VERIFICA DI SICUREZZA:
    // Agiamo SOLO se l'elemento ha la classe '.filter__price_change'
    // ED è contenuto all'interno di un tag <price-range>
    if (slider && slider.matches('price-range .filter__price_change')) {
      const value = slider.value;
      
      // Recuperiamo il simbolo valuta dal blocco del filtro corrente
      const priceRangeBlock = slider.closest('price-range');
      const currencySymbol = priceRangeBlock ? priceRangeBlock.querySelector('.format-currency')?.textContent.trim() : '';

      // Aggiorniamo gli attributi ARIA
      slider.setAttribute('aria-valuenow', value);
      if (currencySymbol) {
        slider.setAttribute('aria-valuetext', `${value} ${currencySymbol}`);
      } else {
        slider.setAttribute('aria-valuetext', value);
      }
    }
  });
});